import React, { FC, Suspense } from 'react';
import LoadingBar from 'react-redux-loading-bar';
import PageBody from 'src/components/ui/PageBody/PageBody';
import { Role } from 'src/store/models/Auth';
import { colors } from 'src/utils/colors';

import { useAppSelector } from '../../../app/hooks';
import AdminRouter from './AdminRouter';
import ManufacturerRouter from './ManufacturerRouter';
import ServiceRouter from './ServiceRouter';
import UnauthenticatedRouter from './UnauthenticatedRouter';

const Router: FC = () => {
  const user = useAppSelector((state) => state.auth.user);

  return user?.apiKey ? (
    <Suspense
      fallback={
        <LoadingBar style={{ backgroundColor: colors()?.colorFumisGreen1 }} />
      }
    >
      <PageBody>
        {user?.role === Role.ADMIN ? (
          <AdminRouter />
        ) : user?.role === Role.MANUFACTURER ? (
          <ManufacturerRouter />
        ) : (
          <ServiceRouter />
        )}
      </PageBody>
    </Suspense>
  ) : (
    <UnauthenticatedRouter />
  );
};

export default Router;
